export default "__VITE_ASSET__uTgH8ukM__"